import type { DateRange } from "@/hooks/useDateRange";

export type CurrencyFormatOptions = {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  symbol?: string;
  symbolPosition?: "prefix" | "suffix";
};

export function formatAnalyticsCurrency(
  value: number,
  {
    minimumFractionDigits = 0,
    maximumFractionDigits = 1,
    symbol = "€",
    symbolPosition = "suffix",
  }: CurrencyFormatOptions = {},
): string {
  const formatted = value.toLocaleString("en-US", {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return symbolPosition === "prefix"
    ? `${symbol}${formatted}`
    : `${formatted}${symbol}`;
}

export function formatAnalyticsDayLabel(
  label: string | number | undefined,
): string {
  const normalized = String(label ?? "").trim();
  if (!normalized) {
    return "—";
  }

  return /^\d+$/.test(normalized) ? `Day ${normalized}` : normalized;
}

export function formatAnalyticsDateRangeLabel(
  dateRange: DateRange,
  fallback: string,
): string {
  const from = dateRange.from;
  const to = dateRange.to;
  if (!from || !to) {
    return fallback;
  }

  const formattedFrom = from.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const formattedTo = to.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return `${formattedFrom} - ${formattedTo}`;
}
